const state = {
  list: [],
};

const getters = {
  customerHistory: (state) => state.list,
};

const actions = {
  async fetchCustomerHistory(
    { commit },
    {
      id,
      action,
      date,
      limit = 500,
      offset = 0,
      q = null,
      orderDir = null,
      orderBy = null,
    }
  ) {
    let requestURL = `/restapi/users/${id}/history/${action}/${date}?limit=${limit}`;
    if (offset) requestURL += `&offset=${offset}`;
    if (orderDir) requestURL += `&order_dir=${orderDir}`;
    if (orderBy) requestURL += `&order_by=${orderBy}`;
    if (q) requestURL += `&q=${q}`;

    const response = await this._vm.$http.get(requestURL);

    commit("setCustomerHistory", response.data);
    return response.data;
  },
};

const mutations = {
  setCustomerHistory: (state, data) => (state.list = data.data),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
